import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Form, FieldArray, formValueSelector } from 'redux-form'
import MultiCoBuyer from './shared/multiCoBuyer'
const MULTI_CO_BUYER_FORM_NAME = 'multi_co_buyer'
const selector = formValueSelector(MULTI_CO_BUYER_FORM_NAME)

const MultiCoBuyerForm = ({ onSubmit = _.noop, isAutoCapitalize }) => {
  return (
    <div>
      <Form onSubmit={onSubmit}>
        <FieldArray
          component={MultiCoBuyer}
          name='cobuyers'
          isAutoCapitalize={isAutoCapitalize}
        />
      </Form>
    </div>
  )
}

MultiCoBuyerForm.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  fieldValues: PropTypes.array,
  onSubmit: PropTypes.func,
  isAutoCapitalize: PropTypes.bool,
}

export default connect(state => {
  return {
    fieldValues: selector(state, 'cobuyers'),
  }
})(MultiCoBuyerForm)

export { MULTI_CO_BUYER_FORM_NAME }
